import { useNavigate, useLocation } from "react-router-dom";
import { Menu, Cherry, Home, Crown, Gift } from "lucide-react";
import { useApp } from "@/context/AppContext";

export function BottomNav() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const { openStore } = useApp();
  const items = [
    ["menu", "Store", Menu, () => openStore("buy")],
    ["games", "Games", Cherry, () => { nav("/"); setTimeout(() => document.querySelector('[data-testid="section-all-games"]')?.scrollIntoView({ behavior: "smooth" }), 50); }],
    ["home", "Home", Home, () => { nav("/"); window.scrollTo({ top: 0, behavior: "smooth" }); }],
    ["vip", "VIP", Crown, () => nav("/vip")],
    ["rewards", "Redeem", Gift, () => openStore("redeem")],
  ];
  const active = pathname === "/vip" ? "vip" : "home";
  return (
    <nav className="bottom-nav md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#151A22]/95 backdrop-blur-xl border-t border-white/10 grid grid-cols-5 pb-[env(safe-area-inset-bottom)]" data-testid="bottom-nav">
      {items.map(([k, l, I, fn]) => (
        <button key={k} data-testid={`bottom-nav-${k}`} onClick={fn} className={`flex flex-col items-center gap-1 py-2.5 text-[11px] font-black uppercase transition-colors ${active === k ? "gc-text" : "text-gray-300"}`}>
          <I size={22} />{l}
        </button>
      ))}
    </nav>
  );
}
